<template>
    <div class="my-library">
        <app-layout class="library-page-template">
            <Row type="flex" style="justify-content: center">
                <i-col :span="24" style="width: 60%; padding:3px 5px 5px">
                    <i-input v-model="keyword" @on-enter="searchInit" placeholder="Search keyword...">
                        <Button @click="clearSearch" slot="append" size="small" style="position: absolute; right: 37px; top: 4px; z-index: 3;" v-show="keyword">
                            <Icon type="ios-close-empty" size="27"/>
                        </Button>
                        <Button @click="searchInit" slot="append" size="small" icon="ios-search"></Button>
                    </i-input>
                </i-col>
                <i-col :span="24" v-if="isSearching || searchResult" class="search">
                    <p v-if="isSearching" align="center">
                        Searching...</p>
                    <p v-if="keyword && !isSearching && searchResult.length <= 0" align="center">
                        No items found</p>
                    <Timeline style="padding: 10px" v-if="!isSearching">
                        <TimelineItem color="#1E89A7" v-if="searchResult['Cope']">
                            <span class="cope-text" style="line-height:12px">
                                <img class="cope-text cat-thumb" shape="square" :src="copeImg"/>
                                Cope
                            </span>
                            <div>
                                <p class="truncate pointer" v-for="(mod, mi) in searchResult['Cope'].modules" :key="mi">
                                    &middot;
                                    <span class="search-module" @click="onGoToDefinition('Cope', mod)">
                                        <b class="cope-text">{{mod.title}}</b><br>
                                        <div class="truncate mod-desc">{{mod.description}}</div>
                                    </span>
                                </p>
                                <!-- <p class="truncate" style="padding-left:25px;" v-for="(itemx,ix) in item.elements" :key="ix">
                                    &middot; <a @click="onGoToDefinition(item, itemx)">{{itemx.title}}</a></p> -->
                            </div>
                        </TimelineItem>
                        <TimelineItem color="#F19B2F" v-if="searchResult['Thrive']">
                            <span class="thrive-text" style="line-height:12px">
                                <img class="thrive-text cat-thumb" shape="square" :src="thriveImg"/>
                                Thrive
                            </span>
                            <div>
                                <p class="truncate pointer" v-for="(mod, mi) in searchResult['Thrive'].modules" :key="mi">
                                    &middot;
                                    <span class="search-module" @click="onGoToDefinition('Thrive', mod)">
                                        <b class="thrive-text">{{mod.title}}</b><br>
                                        <div class="truncate mod-desc">{{mod.description}}</div>
                                    </span>
                                </p>
                                <!-- <p class="truncate" style="padding-left:25px;" v-for="(itemx,ix) in item.elements" :key="ix">
                                    &middot; <a @click="onGoToDefinition(item, itemx)">{{itemx.title}}</a></p> -->
                            </div>
                        </TimelineItem>
                        <TimelineItem color="#83CA27" v-if="searchResult['Nourish']">
                            <span class="nourish-text" style="line-height:12px">
                                <img class="nourish-text cat-thumb" shape="square" :src="nourishImg"/>
                                Nourish
                            </span>
                            <div>
                                <p class="truncate pointer" v-for="(mod, mi) in searchResult['Nourish'].modules" :key="mi">
                                    &middot;
                                    <span class="search-module" @click="onGoToDefinition('Nourish', mod)">
                                        <b class="nourish-text">{{mod.title}}</b><br>
                                        <div class="truncate mod-desc">{{mod.description}}</div>
                                    </span>
                                </p>
                                <!-- <p class="truncate" style="padding-left:25px;" v-for="(itemx,ix) in item.elements" :key="ix">
                                    &middot; <a @click="onGoToDefinition(item, itemx)">{{itemx.title}}</a></p> -->
                            </div>
                        </TimelineItem>
                        <TimelineItem color="#4E1C9B" v-if="searchResult['Heal']">
                            <span class="heal-text" style="line-height:12px">
                                <img class="heal-text cat-thumb" shape="square" :src="healImg"/>
                                Heal
                            </span>
                            <div>
                                <p class="truncate pointer" v-for="(mod, mi) in searchResult['Heal'].modules" :key="mi">
                                    &middot;
                                    <span class="search-module" @click="onGoToDefinition('Heal', mod)">
                                        <b class="heal-text">{{mod.title}}</b><br>
                                        <div class="truncate mod-desc">{{mod.description}}</div>
                                    </span>
                                </p>
                                <!-- <p class="truncate" style="padding-left:25px;" v-for="(itemx,ix) in item.elements" :key="ix">
                                    &middot; <a @click="onGoToDefinition(item, itemx)">{{itemx.title}}</a></p> -->
                            </div>
                        </TimelineItem>
                    </Timeline>
                    <p align="center" v-show="!isSearching">
                        <span @click="clearSearch">
                        <Avatar class="action-back pointer" :src="require('@/assets/back.png')" />
                        </span>
                    </p>
                </i-col>
                <i-col :span="24" v-else>
                    <!-- <LibraryCategories v-if="myUserStories.length > 1" :planId="myUserStories[0].id"/> -->
                    <Collapse v-model="sections" accordion>
                        <Panel name="1" class="cope-panel">
                            <div style="display:inline-block;">
                                <img style="color:#1E89A7;" class="avatar" shape="square" :src="copeImg"/>
                                <div style="color:#1E89A7;padding-left:65px;font-size:18px;line-height:18px;position:absolute;top:15px; right: 35px; left: 15px;">
                                    <span v-if="cope">
                                        <p class="truncate"><b>{{cope.title}}</b><br/></p>
                                        <p class="category-description truncate-2" style="width: 100%;line-height: 15px;">{{removeHTMLTags(cope.data.tip)}}</p>
                                    </span>
                                    <span v-else>
                                        <b>Cope</b><br/>
                                        <p class="category-description" style="width: 100%;">Build resilience against the pressures of life.</p>
                                    </span>
                                </div>
                            </div>
                            <div slot="content">
                                <div class="tracks-list">
                                    <div class="track-item" v-for="(item,i) in groupedItems['Cope']" :key="i" @click="redirect(item, 'Cope')" style="padding:10px 0 10px 15px;border-top:.05em solid #f2f2f2">
                                        <p style="color:#1E89A7;padding:3px 0">
                                            <i class="fa fa-circle" :style="{color: (isVisited(item.id)) ? '#1E89A7':'#38feff'}" style="font-size:10px;"/> &nbsp;
                                            {{item.title}}</p>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel name="2" class="thrive-panel">
                            <div style="display:inline-block;">
                                <img style="color:#F19B2F;" class="avatar" shape="square" :src="thriveImg"/>
                                <div style="color:#F19B2F;padding-left:65px;font-size:18px;line-height:18px;position:absolute;top:15px; right: 35px; left: 15px;">
                                    <span v-if="thrive">
                                        <p class="truncate"><b>{{thrive.title}}</b><br/></p>
                                        <p class="category-description truncate-2" style="width: 100%;line-height: 15px;">{{removeHTMLTags(thrive.data.tip)}}</p>
                                    </span>
                                    <span v-else>
                                        <b>Thrive</b><br/>
                                        <p class="category-description" style="width: 100%;">Infuse your mind with mindfulness exercises.</p>
                                    </span>
                                </div>
                            </div>
                            <div slot="content">
                                <div class="tracks-list">
                                    <div class="track-item" v-for="(item,i) in groupedItems['Thrive']" :key="i" @click="redirect(item, 'Thrive')" style="padding:10px 0 10px 15px;border-top:.05em solid #f2f2f2">
                                        <p style="color:#F19B2F;padding:3px 0">
                                            <i class="fa fa-circle" :style="{color: (isVisited(item.id)) ? '#d0862a':'#facf11'}" style="font-size:10px;"/> &nbsp;
                                            {{item.title}}</p>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel name="3" class="nourish-panel">
                            <div style="display:inline-block;">
                                <img style="color:#83CA27;" class="avatar" shape="square" :src="nourishImg"/>
                                <div style="color:#83CA27;padding-left:65px;font-size:18px;line-height:18px;position:absolute;top:15px; right: 35px; left: 15px;">
                                    <span v-if="nourish">
                                        <p class="truncate"><b class="truncate">{{nourish.title}}</b><br/></p>
                                        <p class="category-description truncate-2" style="width: 100%;line-height: 15px;">{{removeHTMLTags(nourish.data.tip)}}</p>
                                    </span>
                                    <span v-else>
                                        <b>Nourish</b><br/>
                                        <p class="category-description" style="width: 100%">Nourish your body from the inside out.</p>
                                    </span>
                                </div>
                            </div>
                            <div slot="content">
                                <div class="tracks-list">
                                    <div class="track-item" v-for="(item,i) in groupedItems['Nourish']" :key="i" @click="redirect(item, 'Nourish')" style="padding:10px 0 10px 15px;border-top:.05em solid #f2f2f2">
                                        <p style="color:#83CA27;padding:3px 0">
                                            <i class="fa fa-circle" :style="{color: (isVisited(item.id)) ? '#4b7315':'#93df1b'}" style="font-size:10px;"/> &nbsp;
                                            {{item.title}}</p>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel name="4" class="heal-panel">
                            <div style="display:inline-block;">
                                <img style="color:#4E1C9B;" class="avatar" shape="square" :src="healImg"/>
                                <div style="color:#4E1C9B;padding-left:65px;font-size:18px;line-height:18px;position:absolute;top:15px; right: 35px; left: 15px;">
                                    <span v-if="heal">
                                        <p class="truncate"><b class="truncate">{{heal.title}}</b><br/></p>
                                        <p class="category-description truncate" style="width: 100%;line-height: 15px;">{{removeHTMLTags(heal.data.tip)}}</p>
                                    </span>
                                    <span v-else>
                                        <b>Heal</b><br/>
                                        <p class="category-description" style="width: 100%">Facts and myths about mental illness.</p>
                                    </span>
                                </div>
                            </div>
                            <div slot="content">
                                <div class="tracks-list">
                                    <div class="track-item" v-for="(item,i) in groupedItems['Heal']" :key="i" @click="redirect(item, 'Heal')" style="padding:10px 0 10px 15px;border-top:.05em solid #f2f2f2">
                                        <p style="color:#4E1C9B;padding:3px 0">
                                            <i class="fa fa-circle" :style="{color: (isVisited(item.id)) ? '#4E1C9B':'#c695fe'}" style="font-size:10px;"/> &nbsp;
                                            {{item.title}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </Collapse>
                </i-col>
            </Row>
            <!-- <div v-if="loadingTracks || isLoadingLibrary" style="padding:10px;text-align:center;color:#aaa">
                <small><Icon type="load-c" style="animation: ani-demo-spin 1s linear infinite;"/> Updating Data...</small>
            </div> -->
        </app-layout>
    </div>
</template>

<script>
import copeImg from '@/assets/svg/cope.svg'
import thriveImg from '@/assets/svg/thrive.svg'
import nourishImg from '@/assets/svg/nourish.svg'
import healImg from '@/assets/svg/heal.svg'
import { mapGetters } from 'vuex'
import { nextTick } from 'q';
import _ from 'lodash';
import Utils from '@/utils.js'
import LibraryCategories from '@/components/LibraryCategories'
import VueCookie from 'vue-cookie'

export default {
    components: {
        LibraryCategories
    },
    data() {
        return {
            copeImg,
            thriveImg,
            nourishImg,
            healImg,
            searchResult: null,
            isSearching: false,
            visited: JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_COURSE`)) || [],
            loadingTracks: false,
            sections: "",
            keyword: null
        }
    },
    mounted() {
        nextTick( () => {
            this.fetchPackages();
            this.$store.dispatch("addon/getUserAddOns", "patient");
            if( "section" in this.$route.query && this.$route.query.section )
                this.sections = this.$route.query.section.split(",");
        });
        this.keyword = this.$route.query.keyword
        this.searchInit()
    },
    computed: {
        ...mapGetters('brand', ["getSelectedStory"]),
        ...mapGetters('addon', ["myAddOns"]),
        ...mapGetters('user', ["userInfo","brandCategories","brandContacts"]),
        ...mapGetters('library', [
            'myStory',
            'myTracks',
            'isLoadingLibrary',
            'myUserStories'
        ]),
        merger() {
            return _.unionBy(this.myStory.pages, this.myAddOns, "id")
        },
        groupedItems() {
            return _.groupBy( this.merger, 'data.category');
        },
        cope(){
            return this.brandCategories.cope
        },
        thrive(){
            return this.brandCategories.thrive
        },
        nourish(){
            return this.brandCategories.nourish
        },
        heal(){
            return this.brandCategories.heal
        }
    },
    watch: {
        "sections": function(n,o) {
            this.$router.push({query: {"section": n.join()}})
        }
    },
    methods: {
        onGoToDefinition(category, searchMod) {
            let brandSlug = this.$route.params.brandSlug;
            //search for the track that the module belongs to
            var findTrack = null

            this.groupedItems[category].forEach(track => {
                track.data.modules.forEach(mod => {
                    if (mod == searchMod.id){
                        findTrack = track
                        return
                    }
                })
            });

            let trackId = findTrack.id
            let trackTitle = findTrack.title

            var cats = [
                "Cope",
                "Thrive",
                "Nourish",
                "Heal"
            ]

            //set cookie values
            VueCookie.delete(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}PARENT_LIBRARY`);
            VueCookie.delete(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}PARENT_TRACK`);

            VueCookie.set(
                `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}PARENT_LIBRARY`,
                // JSON.stringify(`/${process.env.VUE_APP_DEV_ECOSYSTEM}/library?section=${cats.indexOf(category) + 1}`)
                JSON.stringify(`/${brandSlug}/library?section=${cats.indexOf(category) + 1}`)
            );

            VueCookie.set(
                `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}PARENT_TRACK`,
                // JSON.stringify(`/${process.env.VUE_APP_DEV_ECOSYSTEM}/track/${trackId}?careplan_ids=${findTrack.data.modules.join()}&title=${trackTitle}&category=${category}`)
                JSON.stringify(`/${brandSlug}/track/${trackId}?careplan_ids=${findTrack.data.modules.join()}&title=${trackTitle}&category=${category}`)
            );

            // this.$router.push(`/${process.env.VUE_APP_DEV_ECOSYSTEM}/module/${searchMod.id}?tab=course&title=${searchMod.title}&track_id=${findTrack.id}&careplan_ids=${findTrack.data.modules.join()}&category=${category}`)
            this.$router.push(`/${brandSlug}/module/${searchMod.id}?tab=course&title=${searchMod.title}&track_id=${findTrack.id}&careplan_ids=${findTrack.data.modules.join()}&category=${category}`)
        },
        clearSearch() {
            this.keyword = null;
            this.searchResult = null;
            this.$router.replace({
                query: {
                    keyword: this.keyword
                }
            })
        },
        async searchInit() {
            this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', link_tag: 'Discover Search' });
            if (!this.keyword) {
                this.searchResult = null;
                return false;
            }

            this.$router.replace({
                query: {
                    keyword: this.keyword
                }
            })

            try {
                this.isSearching = true;
                let res = await this.$store.dispatch("library/getSearchResult", {
                    userStory: this.myUserStories[0].id,
                    keyword: this.keyword
                })
                this.searchResult = res;
            } catch(e) {
                console.log(e)
                this.searchResult = null;
            } finally {
                this.isSearching = false;
            }
        },
        getAvatar(stuff) {
            return Utils.getDisplayImage('group', stuff, 'medium')
        },
        async fetchPackages() {
            this.loadingTracks = true;
            try { 
                await this.$store.dispatch("library/getUserStories", Cons[0].BRAND_ID)
            }
            catch(err) { }
            finally {
                this.loadingTracks = false
            }
        },
        isVisited(i) {
            let x = this.visited.findIndex(v => {
                return v === i
            });
            if ( x >= 0 )
                return true;
            return false
        },
        setVisitedItem(i) {
            this.visited = JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_COURSE`)) || [];
            let idx = this.visited.findIndex( v => {
                return v === i
            });

            if ( this.visited.length <= 0 ) {
                this.visited.push(i);
            } else if ( this.visited.length > 0 && idx == -1 ) {
                this.visited.push(i);
            }

            VueCookie.set(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_COURSE`, JSON.stringify(this.visited));
        },
        redirect(item, category){
            if( !item ) return;

            this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: item.id, link_tag: `View Discover ${category} Item`});

            if ( !item.data.modules.join() || item.data.modules.join().length === 0 ) {
                this.$Message({
                    closable: true,
                    durationInSec: 3,
                    title: { content: "Info" },
                    message: { content: "Track is empty at this moment." }
                });
                return false;
            }

            VueCookie.delete(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}PARENT_LIBRARY`);
            VueCookie.set(
                `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}PARENT_LIBRARY`,
                JSON.stringify(this.$route.fullPath)
            );

            this.setVisitedItem(item.id);
            this.setVisitor(category, item.id)

            this.$store.commit('setPageTitle', item.title);
            this.$router.push({ path: "/track/" + item.id, query: {
                careplan_ids: item.data.modules.join(),
                title: item.title,
                category: category
            }});
        },
        setVisitor(category, id) {
            this.$store.commit("points/setVisited", {
                type: "course",
                userStory: this.myUserStories[0].id,
                category: category,
                id
            })
        },
        removeHTMLTags (data){
            if(data)
            return data.replace(/<\/?[^>]+(>|$)/g, "");
        }
    }
}
</script>

<style lang="scss" scoped>
    .truncate-2 {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
    .category-description {
        font-size:14px
    }
    .cope-text {
        color: #1E89A7;
    }
    .thrive-text {
       color: #F19B2F;
    }
    .nourish-text {
        color: #83CA27;
    }
    .heal-text {
        color: #4E1C9B;
    }
    .cat-thumb {
        vertical-align: middle;
        width: 20px;
        height: 20px;
    }
    .search-module {
        b {
            font-size: 14px;
            line-height: 14px;
        }
        .mod-desc {
            padding-left: 8px;
            font-size: 12px;
            line-height: 12px;
        }
    }
    .action-back {
    background: #fff;
    }
</style>


<style>

    .track-item {
        cursor: pointer;
    }

    .avatar {
        font-size: 52px;
        line-height: 50px;
        position: absolute;
        left: 15px;
        top: 12px;
        width: 45px;
        height: 45px;
        background: transparent;
    }

    .avatar.user-stories {
        width: 50px;
        height: 50px;
        top: 8px;
    }

    .library-page-template .loader {
        background: #ddd;
        min-height: 80vh;
    }

    .library-page-template .ivu-collapse-content,
    .library-page-template .ivu-collapse-content>.ivu-collapse-content-box {
        padding: 0;
    }
    .library-page-template .ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
        height: 70px;
        line-height: 50px;
    }
    .library-page-template .ivu-collapse > .ivu-collapse-item > .ivu-collapse-header > .ivu-icon{
        line-height: 72px;
        position: absolute;
        right: 10px;
    }
    .library-page-template .ivu-collapse > .cope-panel > .ivu-collapse-header > .ivu-icon{
        color: #1E89A7;
    }
    .library-page-template .ivu-collapse > .thrive-panel > .ivu-collapse-header > .ivu-icon{
        color: #F19B2F;
    }
    .library-page-template .ivu-collapse > .nourish-panel > .ivu-collapse-header > .ivu-icon{
        color: #83CA27;
    }
    .library-page-template .ivu-collapse > .heal-panel > .ivu-collapse-header > .ivu-icon{
        color: #4E1C9B;
    }
</style>
